import React, { useState } from 'react'
import "../styles/strategies_card.css"
import { useNavigate } from 'react-router-dom';

export default function StrategiesCardComponent({ id, name, description, onOpen, onDelete, onEdit, hit_rate, avg_odds }) {
    const navigate = useNavigate();
    const [openMenu, setOpenMenu] = useState(false);

    const handleOpen = () => {
        navigate(`/strategiak/${id}`);
    }


    return (
        <div className="col-md-4 mb-4">
            <div className="strategy-card-modern h-100">

                {/* FEJLÉC */}
                <div className="strategy-card-header">
                    <h4>{name}</h4>
                </div>

                {/* TARTALOM */}
                <div className="strategy-card-body">
                    <div className="stats-row">

                        <div className="stat-box">
                            <span className="stat-label">Találati arány</span>
                            <span className="stat-value">{hit_rate ?? "-"}%</span>
                        </div>

                        <div className="stat-box">
                            <span className="stat-label">Átlag odds</span>
                            <span className="stat-value">{avg_odds ?? "-"}</span>
                        </div>

                    </div>

                </div>

                {/* META + GOMBOK */}
                <div className="strategy-card-footer">

                    <div className="strategy-actions">
                        <div className="action-menu-wrapper">
                            <button
                                className="btn-more"
                                onClick={() => setOpenMenu(prev => !prev)}
                            >
                                ⋯
                            </button>

                            {openMenu && (
                                <div className="action-menu">
                                    <button onClick={() => onEdit(id)}>Szerkesztés</button>
                                    <button onClick={() => onDelete(id)} className="danger">
                                        Törlés
                                    </button>
                                </div>
                            )}
                        </div>

                        <button
                            className="btn-open"
                            onClick={handleOpen}>
                            Megnyitás
                        </button>
                        {/* {onEdit && (
                            <button 
                                className="action btn-edit"
                                onClick={() => onEdit(id)}>
                                Szerk.
                            </button>
                        )}

                        {onDelete && (
                            <button 
                                className="btn-delete"
                                onClick={() => onDelete(id)}>
                                Törlés
                            </button>
                        )} */}
                    </div>
                </div>
            </div>
        </div>
    );
}